define('businessServices/router/plugins/signupForCustomerRoutePlugin',[
        'constants/signupSessionFlowConstants',
        'settings/navigationConfiguration'
    ],
    function() {
        function signupForCustomerUrlRedirect(urlFragment) {
            if (urlFragment.startsWith("signupForCustomer/") === false || urlFragment.split("/").length < 2) {
                return true;
            }

            const _navigationConfiguration = require('settings/navigationConfiguration');
            const _signupSessionFlowConstants = require('constants/signupSessionFlowConstants');
            const signupPlansRouteUrl = _navigationConfiguration.routesById.signupPlans.url.replace(":flow", _signupSessionFlowConstants.flowAgent);
            return {routeUrl: signupPlansRouteUrl};
        }

        return {
            loadUrlRedirect: signupForCustomerUrlRedirect
        };
    });

